import { defineMessages } from 'react-intl';

export const messages: {
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'search-branch-result.label',
		defaultMessage: 'Branch',
		description:
			'Badge label shown on a branch search result card to identify the result type as a code branch.',
	},
});
